
import { createRouter, createWebHashHistory } from 'vue-router';

import { useAuth } from 'src/composables/auth';
import { useApp } from "src/composables/app";


function passRouteToProps(route) {
	return {
		queryParams: route.query,
		fieldName: route.params.fieldName,
		fieldValue: route.params.fieldValue
	}
}


let routes = [
	//Dashboard routes
	{
		path: '/bitacora',
		name: 'bitacora',
		component: () => import('./pages/home/bitacora.vue'),
		props: true
	},

	// Carrier areas dashboards routes
	{
		path: '/carriers/receipt',
		name: 'carriersreceipt',
		component: () => import('./pages/carriers/receipt.vue'),
	},
	{
		path: '/carriers/dashboard',
		name: 'carriersdashboard',
		component: () => import('./pages/carriers/dashboard.vue'),
	},
	{
		path: '/carriers/yard',
		name: 'carriersyard',
		component: () => import('./pages/carriers/yard.vue'),
	},
	{
		path: '/carriers/shipping',
		name: 'carriersshipping',
		component: () => import('./pages/carriers/shipping.vue'),
	},
	{
		path: '/carriers/map',
		name: 'carriersmap',
		component: () => import('./pages/carriers/map.vue'),
	},
	{
		path: '/carriers/imports',
		name: 'carriersimports',
		component: () => import('./pages/carriers/imports.vue'),
	},
	{
		path: '/carriers/exports',
		name: 'carriersexports',
		component: () => import('./pages/carriers/exports.vue'),
	},


	//tags routes
	{
		path: '/tags/:fieldName?/:fieldValue?', name: 'tagslist',
		component: () => import('./pages/tags/list.vue'),
		props: route => passRouteToProps(route)
	},
	{
		path: '/tags/add',
		name: 'tagsadd',
		component: () => import('./pages/tags/add.vue'),
		props: true
	},
	{
		path: '/tags/edit/:id',
		name: 'tagsedit',
		component: () => import('./pages/tags/edit.vue'),
		props: true
	},

	//tasks routes
	{
		path: '/tasks/:fieldName?/:fieldValue?',
		name: 'taskslist',
		component: () => import('./pages/tasks/list.vue'),
		props: route => passRouteToProps(route)
	},
	{
		path: '/tasks/add',
		name: 'tasksadd',
		component: () => import('./pages/tasks/add.vue'),
		props: true
	},
	{
		path: '/tasks/view/:id',
		name: 'tasksview',
		component: () => import('./pages/tasks/view.vue'),
		props: true
	},
	{
		path: '/tasks/edit',
		name: 'tasksedit/:id',
		component: () => import('./pages/tasks/edit.vue'),
		props: true
	},
	//patrols routes
	{
		path: '/patrols/:fieldName?/:fieldValue?',
		name: 'patrolslist',
		component: () => import('./pages/patrols/list.vue'),
		props: route => passRouteToProps(route)
	},
	{
		path: '/patrols/add',
		name: 'patrolsadd',
		component: () => import('./pages/patrols/add.vue'),
		props: true
	},
	{
		path: '/patrols/edit',
		name: 'patrolsedit/:id',
		component: () => import('./pages/patrols/edit.vue'),
		props: true
	},


	//round routes
	{
		path: '/round/:fieldName?/:fieldValue?',
		name: 'roundlist',
		component: () => import('./pages/round/list.vue'),
		props: route => passRouteToProps(route)
	},
	{
		path: '/round/add',
		name: 'roundadd',
		component: () => import('./pages/round/add.vue'),
		props: true
	},
	{
		path: '/round/view/:id',
		name: 'roundview',
		component: () => import('./pages/round/view.vue'),
		props: true
	},
	{
		path: '/round/edit/:id',
		name: 'roundedit',
		component: () => import('./pages/round/edit.vue'),
		props: true
	},

	//finding routes
	{
		path: '/finding/:fieldName?/:fieldValue?',
		name: 'findinglist',
		component: () => import('./pages/finding/list.vue'),
		props: route => passRouteToProps(route)
	},
	{
		path: '/finding/view/:id',
		name: 'findingview',
		component: () => import('./pages/finding/view.vue'),
		props: true
	},

	//incidents routes
	{
		path: '/incidents/:fieldName?/:fieldValue?',
		name: 'incidentslist',
		component: () => import('./pages/incidents/list.vue'),
		props: route => passRouteToProps(route)
	},
	{
		path: '/incidents/view/:id',
		name: 'incidentsview',
		component: () => import('./pages/incidents/view.vue'),
		props: true
	},

	// reports route
	{
		path: '/reports',
		name: 'reports',
		component: () => import('./pages/reports/index.vue'),
		props: true
	},

	//accesslog routes
	{
		path: '/accesslog/:fieldName?/:fieldValue?',
		name: 'accessloglist',
		component: () => import('./pages/accesslog/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/accesslog/view/:id',
		name: 'accesslogview',
		component: () => import('./pages/accesslog/view.vue'),
		props: true
	},


	//carrieraccesslog routes
	{
		path: '/carrier_accesslog/:fieldName?/:fieldValue?',
		name: 'carrier_accessloglist',
		component: () => import('./pages/carrieraccesslog/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/carrier_accesslog/view/:id',
		name: 'carrier_accesslogview',
		component: () => import('./pages/carrieraccesslog/view.vue'),
		props: true
	},

	// Seals log
	{
		path: "/seals_log",
		name: "seals-logs-index",
		component: () => import("./pages/seal-logs/list.vue"),
	},

	// Box logs
	{
		path: "/box_logs",
		name: "box-logs-index",
		component: () => import("./pages/box-logs/list.vue"),
	},

	//accessrequestpriorities routes
	{
		path: '/accessrequestpriorities/:fieldName?/:fieldValue?',
		name: 'accessrequestprioritieslist',
		component: () => import('./pages/accessrequestpriorities/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/accessrequestpriorities/view/:id',
		name: 'accessrequestprioritiesview',
		component: () => import('./pages/accessrequestpriorities/view.vue'),
		props: true
	},

	{
		path: '/accessrequestpriorities/add',
		name: 'accessrequestprioritiesadd',
		component: () => import('./pages/accessrequestpriorities/add.vue'),
		props: true
	},

	{
		path: '/accessrequestpriorities/edit/:id',
		name: 'accessrequestprioritiesedit',
		component: () => import('./pages/accessrequestpriorities/edit.vue'),
		props: true
	},


	//accessrequests routes
	{
		path: '/accessrequests/:fieldName?/:fieldValue?',
		name: 'accessrequestslist',
		component: () => import('./pages/accessrequests/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/accessrequests/view/:id',
		name: 'accessrequestsview',
		component: () => import('./pages/accessrequests/view.vue'),
		props: true
	},

	{
		path: '/accessrequests/add',
		name: 'accessrequestsadd',
		component: () => import('./pages/accessrequests/add.vue'),
		props: true
	},

	{
		path: '/accessrequests/edit/:id',
		name: 'accessrequestsedit',
		component: () => import('./pages/accessrequests/edit.vue'),
		props: true
	},

	{
		path: '/accessrequests/cardlist1/:fieldName?/:fieldValue?',
		name: 'accessrequestscardlist1',
		component: () => import('./pages/accessrequests/cardlist1.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/accessrequests/cardlist2/:fieldName?/:fieldValue?',
		name: 'accessrequestscardlist2',
		component: () => import('./pages/accessrequests/cardlist2.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/accessrequests/cardlist3/:fieldName?/:fieldValue?',
		name: 'accessrequestscardlist3',
		component: () => import('./pages/accessrequests/cardlist3.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/accessrequests/cardlist4/:fieldName?/:fieldValue?',
		name: 'accessrequestscardlist4',
		component: () => import('./pages/accessrequests/cardlist4.vue'),
		props: route => passRouteToProps(route)
	},

	//carrierrequest routes
	{
		path: '/carrierrequests/:fieldName?/:fieldValue?',
		name: 'carrierrequestslist',
		component: () => import('./pages/carrierrequests/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/carrierrequests/view/:id',
		name: 'carrierrequestsview',
		component: () => import('./pages/carrierrequests/view.vue'),
		props: true
	},

	{
		path: '/carrierrequests/add',
		name: 'carrierrequestsadd',
		component: () => import('./pages/carrierrequests/add.vue'),
		props: true
	},

	{
		path: '/carrierrequests/edit/:id',
		name: 'carrierrequestsedit',
		component: () => import('./pages/carrierrequests/edit.vue'),
		props: true
	},

	{
		path: '/inspections/:fieldName?/:fieldValue?',
		name: 'inspectionslist',
		component: () => import('./pages/inspections/list.vue'), 
		props: route => passRouteToProps(route)
	},

	//accessrequeststatus routes
	{
		path: '/accessrequeststatus/:fieldName?/:fieldValue?',
		name: 'accessrequeststatuslist',
		component: () => import('./pages/accessrequeststatus/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/accessrequeststatus/view/:id',
		name: 'accessrequeststatusview',
		component: () => import('./pages/accessrequeststatus/view.vue'),
		props: true
	},

	{
		path: '/accessrequeststatus/add',
		name: 'accessrequeststatusadd',
		component: () => import('./pages/accessrequeststatus/add.vue'),
		props: true
	},

	{
		path: '/accessrequeststatus/edit/:id',
		name: 'accessrequeststatusedit',
		component: () => import('./pages/accessrequeststatus/edit.vue'),
		props: true
	},


	//permissions routes
	{
		path: '/permissions/:fieldName?/:fieldValue?',
		name: 'permissionslist',
		component: () => import('./pages/permissions/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/permissions/view/:id',
		name: 'permissionsview',
		component: () => import('./pages/permissions/view.vue'),
		props: true
	},

	{
		path: '/permissions/add',
		name: 'permissionsadd',
		component: () => import('./pages/permissions/add.vue'),
		props: true
	},

	{
		path: '/permissions/edit/:id',
		name: 'permissionsedit',
		component: () => import('./pages/permissions/edit.vue'),
		props: true
	},


	//repsestatus routes
	{
		path: '/repsestatus/:fieldName?/:fieldValue?',
		name: 'repsestatuslist',
		component: () => import('./pages/repsestatus/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/repsestatus/view/:id',
		name: 'repsestatusview',
		component: () => import('./pages/repsestatus/view.vue'),
		props: true
	},

	{
		path: '/repsestatus/add',
		name: 'repsestatusadd',
		component: () => import('./pages/repsestatus/add.vue'),
		props: true
	},

	{
		path: '/repsestatus/edit/:id',
		name: 'repsestatusedit',
		component: () => import('./pages/repsestatus/edit.vue'),
		props: true
	},


	//roles routes
	{
		path: '/roles/:fieldName?/:fieldValue?',
		name: 'roleslist',
		component: () => import('./pages/roles/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/roles/view/:id',
		name: 'rolesview',
		component: () => import('./pages/roles/view.vue'),
		props: true
	},

	{
		path: '/roles/add',
		name: 'rolesadd',
		component: () => import('./pages/roles/add.vue'),
		props: true
	},

	{
		path: '/roles/edit/:id',
		name: 'rolesedit',
		component: () => import('./pages/roles/edit.vue'),
		props: true
	},

	//Employees routes
	{
		path: '/employees/:fieldName?/:fieldValue?',
		name: 'employeeslist',
		component: () => import('./pages/employees/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/employees/view/:id',
		name: 'employeesview',
		component: () => import('./pages/employees/view.vue'),
		props: true
	},

	{
		path: '/employees/add',
		name: 'employeesadd',
		component: () => import('./pages/employees/add.vue'),
		props: true
	},

	{
		path: '/employees/edit/:id',
		name: 'employeesedit',
		component: () => import('./pages/employees/edit.vue'),
		props: true
	},


	//userdepts routes
	{
		path: '/userdepts/:fieldName?/:fieldValue?',
		name: 'userdeptslist',
		component: () => import('./pages/userdepts/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/userdepts/view/:id',
		name: 'userdeptsview',
		component: () => import('./pages/userdepts/view.vue'),
		props: true
	},

	{
		path: '/userdepts/add',
		name: 'userdeptsadd',
		component: () => import('./pages/userdepts/add.vue'),
		props: true
	},

	{
		path: '/userdepts/edit/:id',
		name: 'userdeptsedit',
		component: () => import('./pages/userdepts/edit.vue'),
		props: true
	},


	//users routes
	{
		path: '/users/:fieldName?/:fieldValue?',
		name: 'userslist',
		component: () => import('./pages/users/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/users/view/:id',
		name: 'usersview',
		component: () => import('./pages/users/view.vue'),
		props: true
	},

	{
		path: '/index/register',
		name: 'usersuserregister',
		component: () => import('./pages/index/userregister.vue'),
		props: true
	},

	{
		path: '/account/edit',
		name: 'usersaccountedit',
		component: () => import('./pages/account/accountedit.vue'),
		props: true
	},

	{
		path: '/account',
		name: 'usersaccountview',
		component: () => import('./pages/account/accountview.vue'),
		props: true
	},

	{
		path: '/users/add',
		name: 'usersadd',
		component: () => import('./pages/users/add.vue'),
		props: true
	},

	{
		path: '/users/edit/:id',
		name: 'usersedit',
		component: () => import('./pages/users/edit.vue'),
		props: true
	},


	//userstatus routes
	{
		path: '/userstatus/:fieldName?/:fieldValue?',
		name: 'userstatuslist',
		component: () => import('./pages/userstatus/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/userstatus/view/:id',
		name: 'userstatusview',
		component: () => import('./pages/userstatus/view.vue'),
		props: true
	},

	{
		path: '/userstatus/add',
		name: 'userstatusadd',
		component: () => import('./pages/userstatus/add.vue'),
		props: true
	},

	{
		path: '/userstatus/edit/:id',
		name: 'userstatusedit',
		component: () => import('./pages/userstatus/edit.vue'),
		props: true
	},


	//vendors routes
	{
		path: '/vendors/:fieldName?/:fieldValue?',
		name: 'vendorslist',
		component: () => import('./pages/vendors/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/vendors/view/:id',
		name: 'vendorsview',
		component: () => import('./pages/vendors/view.vue'),
		props: true
	},

	{
		path: '/vendors/add',
		name: 'vendorsadd',
		component: () => import('./pages/vendors/add.vue'),
		props: true
	},

	{
		path: '/vendors/edit/:id',
		name: 'vendorsedit',
		component: () => import('./pages/vendors/edit.vue'),
		props: true
	},

	//carrier-companies routes
	{
		path: '/carrier-companies/:fieldName?/:fieldValue?',
		name: 'carriercompanieslist',
		component: () => import('./pages/carrier-companies/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/carrier-companies/view/:id',
		name: 'carriercompaniesview',
		component: () => import('./pages/carrier-companies/view.vue'),
		props: true
	},

	{
		path: '/carrier-companies/add',
		name: 'carriercompaniesadd',
		component: () => import('./pages/carrier-companies/add.vue'),
		props: true
	},

	{
		path: '/carrier-companies/edit/:id',
		name: 'carriercompaniesedit',
		component: () => import('./pages/carrier-companies/edit.vue'),
		props: true
	},

	//accessvip routes
	{
		path: '/accessvip/:fieldName?/:fieldValue?',
		name: 'accessviplist',
		component: () => import('./pages/accessvip/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/accessvip/add',
		name: 'accessvipadd',
		component: () => import('./pages/accessvip/add.vue'),
		props: true
	},

	{
		path: '/accessvip/edit/:id',
		name: 'accessvipedit',
		component: () => import('./pages/accessvip/edit.vue'),
		props: true
	},


	//vendorslevels routes
	{
		path: '/vendorslevels/:fieldName?/:fieldValue?',
		name: 'vendorslevelslist',
		component: () => import('./pages/vendorslevels/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/vendorslevels/view/:id',
		name: 'vendorslevelsview',
		component: () => import('./pages/vendorslevels/view.vue'),
		props: true
	},

	{
		path: '/vendorslevels/add',
		name: 'vendorslevelsadd',
		component: () => import('./pages/vendorslevels/add.vue'),
		props: true
	},

	{
		path: '/vendorslevels/edit/:id',
		name: 'vendorslevelsedit',
		component: () => import('./pages/vendorslevels/edit.vue'),
		props: true
	},

	// Employee categories routes
	{
		path: "/employee-categories",
		name: "employee-categories",
		component: () => import("./pages/employee-categories/list.vue"),
	},

	{
		path: "/employee-categories/view/:id",
		name: "employee-category-view",
		component: () => import("./pages/employee-categories/view.vue"),
		props: true,
	},

	{
		path: "/employee-categories/add",
		name: "employee-category-add",
		component: () => import("./pages/employee-categories/add.vue"),
	},

	{
		path: "/employee-categories/edit/:id",
		name: "employee-category-edit",
		component: () => import("./pages/employee-categories/edit.vue"),
		props: true,
	},

	//vendorsstatus routes
	{
		path: '/vendorsstatus/:fieldName?/:fieldValue?',
		name: 'vendorsstatuslist',
		component: () => import('./pages/vendorsstatus/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/vendorsstatus/view/:id',
		name: 'vendorsstatusview',
		component: () => import('./pages/vendorsstatus/view.vue'),
		props: true
	},

	{
		path: '/vendorsstatus/add',
		name: 'vendorsstatusadd',
		component: () => import('./pages/vendorsstatus/add.vue'),
		props: true
	},

	{
		path: '/vendorsstatus/edit/:id',
		name: 'vendorsstatusedit',
		component: () => import('./pages/vendorsstatus/edit.vue'),
		props: true
	},


	{
		path: '/requestskanban',
		name: 'requestskanban',
		component: () => import('././pages/custom/requestskanban.vue'),
		props: true
	},

	//vehicles routes
	{
		path: '/vehicles/:fieldName?/:fieldValue?',
		name: 'vehicleslist',
		component: () => import('./pages/vehicles/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/vehicles/view/:id',
		name: 'vehiclesview',
		component: () => import('./pages/vehicles/view.vue'),
		props: true
	},

	{
		path: '/vehicles/add',
		name: 'vehiclesadd',
		component: () => import('./pages/vehicles/add.vue'),
		props: true
	},

	{
		path: '/vehicles/edit/:id',
		name: 'vehiclesedit',
		component: () => import('./pages/vehicles/edit.vue'),
		props: true
	},


	//tools routes
	{
		path: '/tools/:fieldName?/:fieldValue?',
		name: 'toolslist',
		component: () => import('./pages/tools/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/tools/view/:id',
		name: 'toolsview',
		component: () => import('./pages/tools/view.vue'),
		props: true
	},

	{
		path: '/tools/add',
		name: 'toolsadd',
		component: () => import('./pages/tools/add.vue'),
		props: true
	},

	{
		path: '/tools/edit/:id',
		name: 'toolsedit',
		component: () => import('./pages/tools/edit.vue'),
		props: true
	},

	//computers routes
	{
		path: '/computers/:fieldName?/:fieldValue?',
		name: 'computerslist',
		component: () => import('./pages/computers/list.vue'),
		props: route => passRouteToProps(route)
	},

	{
		path: '/computers/view/:id',
		name: 'computersview',
		component: () => import('./pages/computers/view.vue'),
		props: true
	},

	{
		path: '/computers/add',
		name: 'computersadd',
		component: () => import('./pages/computers/add.vue'),
		props: true
	},

	{
		path: '/computers/edit/:id',
		name: 'computersedit',
		component: () => import('./pages/computers/edit.vue'),
		props: true
	},
	
	//Password reset routes
	{
		path: '/index/forgotpassword',
		name: 'forgotpassword',
		component: () => import('./pages/index/forgotpassword.vue'),
		props: true
	},
	{
		path: '/index/resetpassword',
		name: 'resetpassword',
		component: () => import('./pages/index/resetpassword.vue'),
		props: true
	},
	{
		path: '/index/resetpassword_completed',
		name: 'resetpassword_completed',
		component: () => import('./pages/index/resetpassword_completed.vue'),
		props: true
	},
	{
		path: '/index/guest_request',
		name: 'guest_request',
		component: () => import('./pages/index/guestrequest.vue'),
		props: true
	},
	{ 
		path: '/index/captcha', 
		name: 'captcha', 
		component: () => import('./pages/index/captcha.vue'), 
		props: true
	},
	{
		path: '/index/aviso_privacidad',
		name: 'aviso_privacidad',
		component: () => import('./pages/index/PrivacyNotice.vue'),
		props: true
	},
	{
		path: '/index/welcome',
		name: 'welcome',
		component: () => import('./pages/index/welcomecompany.vue'),
		props: true
	},
	{
		path: '/index/qrreader',
		name: 'qrreader',
		component: () => import('./pages/index/qrreader.vue'),
		props: true
	},
	{
		path: '/error/forbidden',
		name: 'forbidden',
		component: () => import('./pages/errors/forbidden.vue'),
		props: true
	},
	{
		path: '/error/notfound',
		name: 'notfound',
		component: () => import('./pages/errors/pagenotfound.vue'),
		props: true
	},
	{
		path: '/:catchAll(.*)',
		component: () => import('./pages/errors/pagenotfound.vue')
	},

	// Carrier employees
	{
		path: "/carriers",
		component: () => import("./pages/carrier-employees/list.vue"),
	},

	{
		path: "/carriers/add",
		component: () => import("./pages/carrier-employees/add.vue"),
	},

	{
		path: "/carriers/edit/:id",
		component: () => import("./pages/carrier-employees/edit.vue"),
		props: true,
	},

	{
		path: "/carriers/view/:id",
		component: () => import("./pages/carrier-employees/view.vue"),
		props: true,
	},

	// Carrier vehicles
	{
		path: "/carrier_vehicles",
		component: () => import("./pages/carrier-vehicles/list.vue"),
	},

	{
		path: "/carrier_vehicles/add",
		component: () => import("./pages/carrier-vehicles/add.vue"),
	},

	{
		path: "/carrier_vehicles/edit/:id",
		component: () => import("./pages/carrier-vehicles/edit.vue"),
		props: true,
	},

	{
		path: "/carrier_vehicles/view/:id",
		component: () => import("./pages/carrier-vehicles/view.vue"),
		props: true,
	},

	// Boxes
	{
		path: "/boxes",
		component: () => import("./pages/boxes/list.vue"),
	},

	{
		path: "/boxes/add",
		component: () => import("./pages/boxes/add.vue"),
	},

	{
		path: "/boxes/edit/:id",
		component: () => import("./pages/boxes/edit.vue"),
		props: true,
	},

	{
		path: "/boxes/view/:id",
		component: () => import("./pages/boxes/view.vue"),
		props: true,
	},

	// Asset checkout routes
	{
		path: "/asset_checkouts/dashboard",
		component: () => import("./pages/asset-checkouts/dashboard.vue"),
	},
	{
		path: "/asset_checkouts/airlife",
		component: () => import("./pages/asset-checkouts/airlife.vue"),
	},
    
	{
		path: "/asset_checkouts",
		component: () => import("./pages/asset-checkouts/list.vue"),
	},

	{
		path: "/asset_checkouts/view/:id",
		component: () => import("./pages/asset-checkouts/view.vue"),
		props: true,
	},

	{
		path: "/asset_checkouts/add",
		component: () => import("./pages/asset-checkouts/add.vue"),
	},

	{
		path: "/asset_checkouts/edit/:id",
		component: () => import("./pages/asset-checkouts/edit.vue"),
		props: true,
	},

	{
		path: "/asset_checkouts/authorize/",
		component: () => import("./pages/asset-checkouts/authorize.vue"),
	},

	{
		path: "/employee_forms",
		component: () => import("./pages/employee-forms/list.vue"),
	},

	{
		path: "/employee_forms/add",
		component: () => import("./pages/employee-forms/add.vue"),
	},

	{
		path: "/employee_forms/edit/:id",
		component: () => import("./pages/employee-forms/edit.vue"),
      props: true,
	},
    
  {
		path: "/employee_forms/view/:id",
		component: () => import("./pages/employee-forms/view.vue"),
    props: true,
	},
    
	// Settings routes
	{
		path: "/settings",
		component: () => import("./pages/settings/list.vue"),
	},

	{
		path: "/settings/add",
		component: () => import("./pages/settings/add.vue"),
	},

	{
		path: "/settings/view/:id",
		component: () => import("./pages/settings/view.vue"),
		props: true,
	},
    
  {
		path: "/settings/edit/:id",
		component: () => import("./pages/settings/edit.vue"),
		props: true,
	},
    
];

export default () => {

	const auth = useAuth();


	const user = auth.user;
	if (user) {
		if (auth.isVendor) {
			routes.push({
				path: "/",
				alias: "/access",
				name: "access",
				component: () => import('./pages/accesslog/list.vue'),
				props: route => passRouteToProps(route)
			});
		}
		if (auth.isVendorCarrier) {
			routes.push({
				path: "/",
				alias: "/carrierrequests",
				name: "carrierrequests",
				component: () => import('./pages/carrierrequests/list.vue'),
				props: route => passRouteToProps(route)
			});
		}

		if (auth.isAdmin || auth.isSupervisor) {
			routes.push(...[
				{
					path: "/audits/index/:fieldName?/:fieldValue?",
					name: "auditsindex",
					component: () => import("./pages/audits/index.vue"),
					props: route => passRouteToProps(route),
				},

				{
					path: "/audits/view/:auditType/:id",
					name:"auditsview",
					component: () => import("./pages/audits/view.vue"),
					props: true,
				},
			]);
		}

		routes.push({ path: '/', alias: '/home', name: 'home', component: () => import(`./pages/home/home.vue`) });
		routes.push({ path: '/home/guard', alias: '/home/guard', name: 'home_guard', component: () => import(`./pages/home/guardhome.vue`) });
		routes.push({ path: '/home/patrol', alias: '/home/patrol', name: 'home_patrol', component: () => import(`./pages/home/patrolhome.vue`) });

	}
	else {
		routes.push({ path: '/', alias: '/index', name: 'index', component: () => import('./pages/index/index.vue') });
	}

	const router = createRouter({
		history: createWebHashHistory(),
		routes,
		scrollBehavior(to, from, savedPostion) {
			if (savedPostion) return savedPostion;
			return { top: 0 }
		}
	});

	router.beforeEach((to, from, next) => {
		const user = auth.user;
		let path = to.path;
		let authRequired = auth.pageRequiredAuth(path);
		if (authRequired) {
			if (!user) {
				return next({ path: '/', query: { nexturl: to.fullPath } });
			}
			//authorize user

			if (!auth.canView(path)) {
				console.log("Cant view: " + path);
				return next({ path: "/error/forbidden" });
			}
		}

		if (user && to.name == "index") {
			//already logged in, show home when try to access index page
			return next({ path: "/home" });
		}

		//navigate to redirect url if available
		if (to.name == "home" && to.query.nexturl) {
			return next({ path: to.query.nexturl });
		}

		//close dialog from previous page
		const app = useApp();
		app.closeDialogs();


		next();
	});

	return router;
}
